import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import Tracking from '@glass/shared/modules/tracking/Tracking';
import useFunctionTracking from '@glass/shared/modules/tracking/useFunctionTracking';

function SocialShareLink({
  Button,
  Icon,
  label,
  size,
  beforeOnClick: beforeOnClickProp,
  onShareWindowClose: onShareWindowCloseProp,
  className,
  hashtag,
  hashtags,
  related,
  quote,
  url,
  title,
  source,
  summary,
  via,
  media,
  description,
  subject,
}) {
  const trackPropsBefore = useMemo(
    () => ({
      action: Tracking.ACTIONS.START,
      label,
    }),
    [label],
  );

  const trackPropsClose = useMemo(
    () => ({
      action: Tracking.ACTIONS.END,
      label,
    }),
    [label],
  );

  const beforeOnClick = useFunctionTracking(
    Tracking.EVENTS.SHARE,
    trackPropsBefore,
    beforeOnClickProp,
  );
  const onShareWindowClose = useFunctionTracking(
    Tracking.EVENTS.SHARE,
    trackPropsClose,
    onShareWindowCloseProp,
  );

  return (
    <Button
      beforeOnClick={beforeOnClick}
      className={className}
      description={description}
      hashtag={hashtag}
      hashtags={hashtags}
      media={media}
      quote={quote}
      related={related}
      source={source}
      subject={subject}
      summary={summary}
      title={title}
      url={url}
      via={via}
      onShareWindowClose={onShareWindowClose}
    >
      <Icon round size={size} />
    </Button>
  );
}

SocialShareLink.propTypes = {
  beforeOnClick: PropTypes.func,
  Button: PropTypes.node,
  className: PropTypes.string,
  description: PropTypes.string,
  hashtag: PropTypes.string,
  hashtags: PropTypes.arrayOf(PropTypes.string),
  Icon: PropTypes.node,
  label: PropTypes.string,
  media: PropTypes.string,
  onShareWindowClose: PropTypes.func,
  quote: PropTypes.string,
  related: PropTypes.arrayOf(PropTypes.string),
  size: PropTypes.number,
  source: PropTypes.string,
  subject: PropTypes.string,
  summary: PropTypes.string,
  title: PropTypes.string,
  url: PropTypes.string,
  via: PropTypes.string,
};

export default SocialShareLink;
